import  { useRef, useEffect, useState, useContext } from "react";
import $ from "jquery"; 
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import ProductoAgotadoBox from "./ProductoAgotadoBox";
import PodriaInteresarte from "./PodriaInteresarte";
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { Fancybox } from "@fancyapps/ui";
import imgLayer from "@assets/images/layer_gr.png";
import { CartContext } from "@context/CardContext";
import { TokenContext } from "@context/TokenContext";
import { useAuth } from "@context/AuthContext";
import axios from "@fetch/axios"
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import { useTranslation } from "@hooks/useTranslation";
import {Helmet} from "react-helmet";

import LoadingCardDetail from "@pages/detalle/LoadingCardDetail";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Spinner from "@components/Spinner";

const DetallesProducto = () => {
  const MySwal = withReactContent(Swal)
  const [product, setProduct] = useState(null);
  const [thumbnails, setThumbnails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [quantity, setQuantity] = useState(0);
  const [maxquantity, setMaxquantity] = useState(0);
  const [thumbnailActive, setThumbnailActive] = useState(0);
  const [tallasActive, setTallasActive] = useState(0);
  const [selectedTalla, setSelectedTalla] = useState(null);
  const [letterTalla, setLetterTalla] = useState(null);
  const [price, setPrice] = useState(null);
  const [priceOffer, setPriceOffer] = useState(null);
  const { uri } = useParams();
  const location = useLocation();
  const ThumbnailRef = useRef(null);
  const TallasRef = useRef(null);
  const GranImagen = useRef(null);
  const navigate = useNavigate();
  const ImageActiveIndex = 0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clickSize, setClickSize] = useState(false);
  const { addToCartVerified,addToCartGuest, addPrevent, removePrevent } = useContext(CartContext);
  const { getToken } = useContext(TokenContext);
  const { openAuth } = useAuth();
  const { lang, currency } = useContext(LanguageCurrencyContext);
  const { translate } = useTranslation();
  const [loading, setLoading] = useState(true)
  const [mainImage, setMainImage] = useState(null);
  const [showSocials, setShowSocials] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [selectedColor, setSelectedColor] = useState(null);
  const [productColors, setProductColors] = useState([]);
  const url = process.env.REACT_APP_URL + "detalles-producto/" + (product ? product.uri : "");
  const user = JSON.parse(localStorage.getItem('user_arteonu') ?? null)

  const toggleSocials = () => {
    setShowSocials(!showSocials);
  };

  const handleCopyLink = (event) => {

    event.preventDefault();

    navigator.clipboard.writeText(url).then(() => {

      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 3000);
    });
  };

  const changeColor = (image) => {
    if (!product || !product.colors || !image || product.usa_colors_image == 1) return null;

    const normalize = (u) => (typeof u === 'string' ? u.replace(/\\\//g, '/').replace(/ /g, '%20') : u);
    const target = normalize(image);

    for (const color of product.colors) {
      if (Array.isArray(color.galleries) && color.galleries.length > 0) {
        for (const gallery of color.galleries) {
          const galleryImage = normalize(gallery?.image);
          const galleryThumb = normalize(gallery?.thumb);
          if (galleryImage === target || galleryThumb === target) {
            // set both selectedColor and the main image atomically (React will re-render once)
            setSelectedColor(color.id);
           const display = changeUrlColor(gallery.image) || gallery.image || image;
           setMainImage(display);
            return;
          }
        }
      }
    }

    // fallback: set selectedColor to null and mainImage to passed image
    setSelectedColor(null);
    setMainImage(changeUrlColor(image) || image);
    return;
  }

  function Thumbnail() {

    return (
      <ul ref={ThumbnailRef}>
        {thumbnails && thumbnails.length > 0 ? thumbnails.map((image, index) => (
          <li
            key={index}
            style={{ backgroundImage: `url(${image})` }}
            onClick={()=>changeColor(image)}
            className={index === ImageActiveIndex ? "Selected" : ""}
          ></li>
        )) : null}
      </ul>
    );
  }

  function ThumbnailPos(plus) {
    if (!thumbnails || thumbnails.length === 0) return;
    
    let newThumbnailActive = thumbnailActive;
    if (plus === 1 && newThumbnailActive < thumbnails.length - 1) {
      newThumbnailActive += 1;
    }
    if (plus !== 1 && newThumbnailActive > 0) {
      newThumbnailActive -= 1;
    }
    setThumbnailActive(newThumbnailActive);
    
    // Obtener la imagen completa correspondiente al color seleccionado
    const selectedColorData = productColors.find(color => color.id === selectedColor);
    let imageUrl = thumbnails[newThumbnailActive]; // fallback al thumbnail

    if(product.usa_colors_image == 0 && imageUrl){
      changeColor(imageUrl)
    }

    if (selectedColorData && selectedColorData.galleries && selectedColorData.galleries[newThumbnailActive]) {
      imageUrl = selectedColorData.galleries[newThumbnailActive].image;
    }


    if (GranImagen.current && imageUrl) {
      $(GranImagen.current).css("background-image", `url(${imageUrl})`);
    }

    if (ThumbnailRef.current) {
      Array.from(ThumbnailRef.current.children).forEach((thumbnail, index) => {
        thumbnail.classList.remove("Selected");
        if (newThumbnailActive === index) {
          thumbnail.classList.add("Selected");
        }
      });
    }
  }

  function CurrentPosTalla(sizes, talla) {
    return sizes.findIndex((obj) => obj.letter === talla);
  }

  function TallasPos(plus) {
    let newTallasActive = tallasActive;
    if (plus === 1 && newTallasActive < product.sizes.length - 4) {
      newTallasActive += 1;
    }
    if (plus !== 1 && newTallasActive > 0) {
      newTallasActive -= 1;
    }
    setTallasActive(newTallasActive);

    let extra = 1.15 * (newTallasActive - 1);
    extra = extra < 0 ? 0 : extra;
    let left = 26 * newTallasActive;
    left -= extra;
    TallasRef.current.firstElementChild.style.marginLeft = `-${left}%`;
  }

  const handleIncrement = () => {

    if (!letterTalla) {
      MySwal.fire({
        text: translate('error.size'),
        icon: 'error',
        title: 'Oops...'

      })
      return
    }
    if (quantity < maxquantity) {
      setQuantity(quantity + 1);
    }
  };

  const handleDecrement = () => {
    if (!letterTalla) {
      MySwal.fire({
        text: translate('error.size'),
        icon: 'error',
        title: 'Oops...'

      })
      return
    }
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleColorClick = (colorId) => {
    setSelectedColor(colorId);
    
    // Encontrar el color seleccionado
    const selectedColorData = productColors.find(color => color.id === colorId);
    
    // Verificar si el color tiene imágenes específicas
    if (product.usa_colors_image &&  selectedColorData && selectedColorData.galleries && selectedColorData.galleries.length > 0) {
      // El color tiene imágenes específicas - usar las imágenes del color seleccionado
      const newThumbnails = selectedColorData.galleries.map((img) => img.thumb);
      setThumbnails(newThumbnails);
      
      // Actualizar la imagen principal con la primera imagen del color seleccionado
      setThumbnailActive(0);
      if (GranImagen.current && selectedColorData.galleries.length > 0) {
        $(GranImagen.current).css("background-image", `url(${selectedColorData.galleries[0].image})`);
      }
      
      // Actualizar las miniaturas en el DOM
      if (ThumbnailRef.current) {
        Array.from(ThumbnailRef.current.children).forEach((thumbnail, index) => {
          thumbnail.classList.remove("Selected");
          if (index === 0) {
            thumbnail.classList.add("Selected");
          }
        });
      }
    } else {
      // El color NO tiene imágenes específicas - usar la galería general del producto
      if (product.gallery && product.gallery.length > 0) {
        const generalThumbnails = product.gallery.map((img) => img.thumb);
        setThumbnails(generalThumbnails);
        
        // Actualizar la imagen principal con la primera imagen de la galería general
        // setThumbnailActive(0);
        if (GranImagen.current && product.gallery.length > 0) {
          $(GranImagen.current).css("background-image", `url(${product.gallery[0].image})`);
        }
        
        // Actualizar las miniaturas en el DOM
        if (ThumbnailRef.current) {
          Array.from(ThumbnailRef.current.children).forEach((thumbnail, index) => {
            thumbnail.classList.remove("Selected");
            if (index === 0) {
              thumbnail.classList.add("Selected");
            }
          });
        }
      }
    }
  };

  const handleTallaClick = (item) => {
    setClickSize(true)              //pinta los precios de rebaja detallados
    setSelectedTalla(item.id);     //obtiene el id de la talla saeleccionada
    setLetterTalla(item.letter)    //obtiene la letra de la talla seleccionada
    setMaxquantity(item.quantity)  //obtiene la maxima cantidad disponible por esa talla seleccionada
    setPrice(item.price ?? product.price)
    setPriceOffer(item.price_offer ?? product.price_offer)

    //colocar el numero de cantida si la talla ya esta en el carrito
    const items = JSON.parse(localStorage.getItem('cart') || '[]')

    if (items.length > 0) {

      const existingItem = items.find(cartItem =>
        cartItem.id === product.id && parseInt(cartItem.size_id) === item.id
      );

      if (existingItem?.quantity) {
        setQuantity(existingItem.quantity)
      } else {
        setQuantity(0)
      }

    } else {

      setQuantity(0)                 //resetea el contador a 0
    }

  };

  const agregarAlCarrito = () => {

    if (!letterTalla ) {
      MySwal.fire({
        text: translate('error.size'),
        icon: 'error',
        title: 'Oops...'
      })
      return
    }

    if (!quantity || quantity < 1) {
      MySwal.fire({
        text: translate('error.quanty'),
        icon: 'error',
        title: 'Oops...'
      })
      return
    }

    if(user && !user.date_birth && user.verified){
      MySwal.fire({
        text: translate('error.date_birth'),
        icon: 'error',
        title: 'Oops...',
        confirmButtonText: translate('confirmation.send14'),
        showCancelButton: true,
        cancelButtonText: translate('confirmation.send13') || 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/mi-perfil/editar-datos');
        }
      });
      return
    }

    // Obtener la imagen del color seleccionado
    const selectedColorData = productColors.find(color => color.id === selectedColor);
    let desktopImage = '';
    
    if (selectedColorData && selectedColorData.galleries && selectedColorData.galleries.length > 0) {
      desktopImage = selectedColorData.galleries[0].image;
    } else if (product.gallery && product.gallery.length > 0) {
      desktopImage = product.gallery[0].image;
    }
    
    const selectedColorName = selectedColorData ? selectedColorData.name : '';

    const item = {
      "id": product.id,
      "size_id": selectedTalla,
      "color_id": selectedColor || null,
      "color_name": selectedColorName || null, // Agregar nombre del color
      "quantity": quantity,
      "price": price,
      "price_offer": priceOffer,
      "name": product.name,
      "size": letterTalla,
      "description": product.description,
      "uri": product.uri,
      "desktop_image": desktopImage // Usar la imagen del color seleccionado
    };

    setLoading(false)
    //guardar en el storage temporalmente el producto recien agregado
    addPrevent(item)

    if (!getToken()) {
      addToCartGuest(item);      
    }else{
      addToCartVerified(item);
    }


    setTimeout(() => {
      setLoading(true)
      navigate('/agregado-carrito');
    }, 2000);
  };

  const comprarAhora = () => {

    if (!letterTalla ) {
      MySwal.fire({
        text: translate('error.size'),
        icon: 'error',
        title: 'Oops...'
      })
      return
    }

    if (!quantity || quantity < 1) {
      MySwal.fire({
        text: translate('error.quanty'),
        icon: 'error',
        title: 'Oops...'
      })
      return
    }

    if(user && !user.date_birth && user.verified){
      MySwal.fire({
        text: translate('error.date_birth'),
        icon: 'error',
        title: 'Oops...',
        confirmButtonText: translate('confirmation.send14'),
        showCancelButton: true,
        cancelButtonText: translate('confirmation.send13') || 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/mi-perfil/editar-datos');
        }
      });
      return
    }

    // Obtener la imagen del color seleccionado
    const selectedColorData = productColors.find(color => color.id === selectedColor);
    let desktopImage = '';
    
    if (selectedColorData && selectedColorData.galleries && selectedColorData.galleries.length > 0) {
      desktopImage = selectedColorData.galleries[0].image;
    } else if (product.gallery && product.gallery.length > 0) {
      desktopImage = product.gallery[0].image;
    }
    
    const selectedColorName = selectedColorData ? selectedColorData.name : '';

    const item = {
      "id": product.id,
      "size_id": selectedTalla,
      "color_id": selectedColor || null,
      "color_name": selectedColorName || null,
      "quantity": quantity,
      "price": price,
      "price_offer": priceOffer,
      "name": product.name,
      "size": letterTalla,
      "description": product.description,
      "uri": product.uri,
      "desktop_image": desktopImage
    };

    if (!getToken()) {
      addToCartGuest(item);  
      navigate("/checkout-guest")
    }else{
      addToCartVerified(item);
      navigate("/checkout-envio")
    }

  }

  const AddToHeart = async (event, id) => {

    try {

      if (!getToken()) {
        openAuth('IniciarSesionWith');
        return
      }
      const res = await axios.put(
        "/products/favorite",
        {
          product_id: id,
          status: !product.favorite
        },
        {
          headers:
          {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Authorization": "Bearer " + getToken()
          }
        }
      );
      product.favorite = !product.favorite;

      event.target.classList.toggle('icon-Hearty');
      event.target.classList.toggle('icon-HeartFill');
      if (res.data.errors) {
        MySwal.fire({
          text:res.data.message,
           icon: 'error',
           title: 'Oops...'
        })
      }
    } catch (error) {
      MySwal.fire({
        text: translate('error.no_fa'),
        icon: 'error',
        title: 'Oops...'
      })
    }
  }

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const changeUrlColor = (image) => {
    if (image) {
      // Remover backslashes y reemplazar espacios por %20
      let url = image
        .replace(/\\\//g, '/')
        .replace(/ /g, '%20');
      return url;
    }
    return null;
  }

  useEffect(()=>{

    // leer query string ?add=true (por defecto false)
    const params = new URLSearchParams(window.location.search);
    const add = params.get('add') === 'true';

    const item = JSON.parse(localStorage.getItem('add_cart_arteonu',null) ?? null);

    // validar tanto el item como el query string iitem (por defecto iitem = false)
    if(item && add){

      setLoading(false)
      addToCartVerified(item);
      //guardar en el storage temporalmente el producto recien agregado
      addPrevent(item)
      localStorage.removeItem('add_cart_arteonu')

      setTimeout(() => {
        setLoading(true)
        navigate('/agregado-carrito');
      }, 2000);

    }else{
      removePrevent();
    }

    const buy_cart_arteonu = JSON.parse(localStorage.getItem('buy_cart_arteonu',null) ?? null);

    if(buy_cart_arteonu){
      try {
          addToCartVerified(buy_cart_arteonu);
          localStorage.removeItem('buy_cart_arteonu')
          navigate("/checkout-guest")
        } catch (error) {
          MySwal.fire({
            text: translate('error.geral'),
            icon: 'error',
            title: 'Oops...'
          })
        }
    }
  },[])

  useEffect(() => {
    setIsLoading(true);
    axios.get(`/products/detail?uri=${uri}` + `&lang=` + lang + `&currency=` + currency, {
      headers: { 'Authorization': 'Bearer ' + getToken() }
    })
      .then((response) => {
        setProduct(response.data);
        setPrice(response.data.price)
        
        // Validar que exista gallery antes de hacer map
        if (response.data.gallery && response.data.gallery.length > 0) {
          setThumbnails(response.data.gallery.map((img) => img.thumb));
        }
        
        setSelectedTalla(response.data.talla);
        if (response.data.sizes && response.data.sizes.length > 0) {
          setTallasActive(CurrentPosTalla(response.data.sizes, response.data.talla));
        }
        
        // Inicializar colores del producto usando la estructura real del backend
        if (response.data.colors && response.data.colors.length > 0) {
          setProductColors(response.data.colors);
          setSelectedColor(response.data.colors[0].id);
          
          // Usar las imágenes del primer color como thumbnails iniciales
          if (response.data.usa_colors_image && response.data.colors[0].galleries && response.data.colors[0].galleries.length > 0) {
            setThumbnails(response.data.colors[0].galleries.map((img) => img.thumb));
            setMainImage(changeUrlColor(response.data.colors[0].galleries[0].image) || response.data.colors[0].galleries[0].image);
          }
        } else {
          // Si no hay colores, usar la galería principal del producto (si existe)
          if (response.data.gallery && response.data.gallery.length > 0) {
            setThumbnails(response.data.gallery.map((img) => img.thumb));
            setMainImage(changeUrlColor(response.data.gallery[0].image) || response.data.gallery[0].image);
          }
        }
        
       
      })
      .catch((error) => {
        console.error("Error fetching product data:", error)
        navigate('/404')

      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [uri, lang, currency]);

  useEffect(() => {
    // Código jQuery para gestionar eventos después de renderizar el DOM
    $(".Thumbnail li").on("click", function () {
      const index = $(this).index();
      $(this).siblings().removeClass("Selected");
      $(this).addClass("Selected");
      
      // Validar que thumbnails existe y tiene elementos
      if (!thumbnails || thumbnails.length === 0 || index >= thumbnails.length) {
        return;
      }
      
      // Obtener la imagen completa correspondiente al color seleccionado
      const selectedColorData = productColors.find(color => color.id === selectedColor);
      let imageUrl = thumbnails[index]; // fallback al thumbnail
      
      if (selectedColorData && selectedColorData.galleries && selectedColorData.galleries[index]) {
        imageUrl = selectedColorData.galleries[index].image;
      }
      
      if (GranImagen.current && imageUrl) {
        $(GranImagen.current).css("background-image", `url(${imageUrl})`);
      }
      // normalizar/convertir url antes de setear
      const display = changeUrlColor(imageUrl) || imageUrl;
      setMainImage(display);
      setThumbnailActive(index);
    });

    Fancybox.bind("[data-fancybox]", {});

    // Cleanup: elimina listeners para evitar fugas de memoria
    return () => {
      $(".Thumbnail li").off("click");
      Fancybox.unbind("[data-fancybox]"); // Limpieza si es necesario
    };
  }, [thumbnails, productColors, selectedColor]);

  // Efecto para hacer scroll a PodriaInteresarte cuando viene de AgregadoCarrito
  useEffect(() => {
    if (location.state?.scrollToInteresarte && product && product.related && product.related.length > 0) {
      // Esperar a que el DOM se actualice completamente
      const scrollToElement = () => {
        const element = document.getElementById("PodriaInteresarte");
        if (element) {
          setTimeout(() => {
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 250;
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth"
            });
            // Limpiar el estado para evitar scrolls repetidos
            window.history.replaceState({}, document.title);
          }, 300);
        } else {
          // Si el elemento aún no existe, intentar de nuevo después de un breve delay
          setTimeout(scrollToElement, 100);
        }
      };
      scrollToElement();
    }
  }, [product, location.state]);

  return (
    <>
      {isLoading || !product ? (
        <div className="loading-container">
          <LoadingCardDetail />
        </div>
      ) : (
          <>
            {!loading && <Spinner />}

            {product &&
              <Helmet>
                <meta name="title" content={product.name} />
                <meta name="description" content={product.description} />
                <meta property="og:url" content={url} />
                <meta property="og:title" content={product.name} />
                <meta property="og:description" content={product.description} />
                <meta property="og:image" content={thumbnails[ImageActiveIndex]} />
              </Helmet>}

            <div className={`CategoryTitle pt-tophead`}>
              <ul className="Breadcrumb">
                <li><Link to="/home">Home</Link></li>
                {product && <li><Link to={`/category/${product.category_uri}`}>{product.category}</Link></li>}
                {product && <li><Link to={`/category/${product.category_uri}/${product.subcategory_uri}`}>{product.subcategory}</Link></li>}
                <li>{product ? product.name : ''}</li>
              </ul>
              <h3>{product ? product.name : ''}</h3>
            </div>


            {product.sizes.every(size => size.quantity === 0) && <ProductoAgotadoBox product={product} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />}

            <section className="DetallesProducto" >

              <div>
                {/* ColeccionItems */}
                <div className="ProductoImagenes">
                       <div
                         ref={GranImagen}
                         style={{
                           backgroundImage: `url(${ mainImage ?? (thumbnails?.[ImageActiveIndex] ?? '') })`,
                           backgroundSize: 'cover',
                           backgroundPosition: 'center'
                         }}
                       >
                    <div className="RotateFlag">
                      {product.web_exclusive ? (
                        <div className="icon-CursorClick">WEB EXCLUSIVE</div>
                      ) : ''}
                      {product.limited_edition ? (
                        <div className="icon-CrownSimple">LIMITED EDITION</div>
                      ) : ''}
                    </div>
                    <div className="ico-instagram">
                      <i
                        className={!product.favorite ? "icon-Hearty" : "icon-HeartFill"}
                        style={{ color: !product.favorite ? "" : "red" }}
                        onClick={(event) => { AddToHeart(event, product.id) }}
                      ></i>
                    </div>
                    <div>
                      {/* <FigureProduct imagedesktop={product.desktop_image} imagemovile={product.movile_image} uri={product.uri} /> */}
                      {/* <i
                        className={!product.favorite ? "icon-Hearty" : "icon-HeartFill"}
                        style={{ color: !product.favorite ? "" : "red" }}
                        onClick={(event) => { AddToHeart(event, product.id); }}
                      ></i> */}
                      <i className="icon-Share" onClick={toggleSocials}></i>
                      {showSocials && (
                        <div className="socials-list">
                          <a target="_blank" href={'https://www.facebook.com/sharer/sharer.php?u=' + url} className="social-icon facebook"></a>
                          <a href="#" className="social-icon link" onClick={handleCopyLink}></a>
                        </div>
                      )}
                      {showNotification && (
                        <div className="notification-banner">
                          {translate('product.link')}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="Thumbnail" data-i={thumbnailActive}>
                    <div className="icon-CaretLeft" onClick={() => ThumbnailPos(-1)}></div>
                    {Thumbnail()}
                    <div className="icon-CaretRight" onClick={() => ThumbnailPos(1)}></div>
                  </div>
                </div>
                <div className="ProductoDescripcion">
                  <div>
                    <div className="ItemDesc">
                      {product.sizes.every(size => size.quantity === 0) && (
                        <div className="NoDisponible">{translate('product.no_available')}</div>
                      )}

                      {!clickSize ?
                        <>
                          {product.price_offer && product.offer_price_range && <div className="textpromo">{translate('product.discount')}</div>}
                        </>
                        :
                        <>
                          {/* Si hay un precio de oferta de la talla o producto, pintamos la rebaja, 
                          sino consultamos si el producto en si tiene oferta */}
                          {priceOffer && <div className="textpromo">{translate('product.discount')}</div>}
                        </>
                      }

                      <h4>{product.name}</h4>
                      <ul>
                        <li>{product.collection}</li>
                      </ul>

                      {!clickSize ?
                        <>
                          {/* Si tiene precio de oferta y rango de oferta, pintamos el rango de oferta, sino, pintamos el rango de precio */}
                          {(product.price_offer && product.offer_price_range) ?
                            <>
                              <div className="grid-price">
                                <span>${product.price_range}</span>
                                <div className="promo">${product.offer_price_range}</div>
                              </div>
                            </>

                            : <h6>${product.price_range}</h6>
                          }
                        </>
                        :
                        <>
                          {/* Si no existe un precio de oferta de producto, ni precio de oferta por talla, pintamos el precio del producto */}
                          {!priceOffer && <h6>${price}</h6>}

                          {/* Si existe un precio por talla, imprimimos el precio de la talla, sino, imprimiremos por el precio de oferta del produto */}
                          {priceOffer &&
                            <div className="grid-price">
                              <span>${price}</span>
                              <div className="promo">${priceOffer} </div>
                            </div>
                          }
                        </>

                      }


                      <em>{product.description}</em>
                    </div>

                    {/* Selector de colores - Solo mostrar si hay colores disponibles */}
                    {productColors.length > 0 && (
                      <div className="SeleccionaColor">
                        <h6>
                          {translate('product.select_color')}: 
                          {selectedColor && (
                            <span className="selected-color-name">
                              {productColors.find(color => color.id === selectedColor)?.name || ''}
                            </span>
                          )}
                        </h6>
                        <div className="color-options">
                          {productColors.map((color) => (
                            <div
                              key={color.id}
                              className={`color-circle ${selectedColor === color.id ? 'selected' : ''} ${color.use_image === 1 ? 'color-image' : ''}`}
                              style={color.use_image === 1 ? 
                                { backgroundImage: `url(${changeUrlColor(color.image_path)})`, backgroundSize: 'cover', backgroundPosition: 'center' } : 
                                { backgroundColor: color.hex_code }
                              }
                              onClick={() => handleColorClick(color.id)}
                              title={color.name}
                            >
                              {selectedColor === color.id && (
                                <div className="color-check">
                                  <i className="icon-Check"></i>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="SeleccionaTalla" data-i={tallasActive}>
                      <h6>{translate('product.select_size')}:</h6>
                      {product.find_your_size && <div className="text"><strong>{translate('product.important')}: </strong>{translate('product.size_information')} </div>}
                      <div>
                        <div className="icon-CaretLeft" onClick={() => TallasPos(-1)}></div>
                        <ul ref={TallasRef}>
                          {product.sizes.map((item, index) => (
                            <li
                              key={index}
                              className={`${item.id === selectedTalla ? "Selected" : ""
                                } ButtonLightMedium ${item.quantity > 0 ? "" : "Disabled"
                                }`}
                              onClick={() => handleTallaClick(item)}
                            >
                              {item.letter}
                            </li>
                          ))}
                        </ul>
                        <div
                          className="icon-CaretRight"
                          onClick={() => TallasPos(1)}
                        ></div>
                      </div>
                    </div>

                    {product.find_your_size && <div className="EncuentraTalla">
                      <a
                        href="#modal-talla"
                        data-fancybox
                        data-src="#modal-talla"
                        data-type="inline"
                      >
                        <i className="icon-Shirt"></i>
                        <em>{translate('product.find_size')}</em>
                      </a>
                    </div>}

                    <a className="link-mail" href={translate('product.mailto', { sku: product.sku })} target="_blank" rel="noopener noreferrer">
                    {translate('product.contact', { sku: product.sku })}<br />
                        {translate('product.contact2', { sku: product.sku })}
                    </a>

                    <div className="SeleccionaCantidad" >
                      <h6>{translate('product.quanty')}:</h6>
                      <div>
                        <div className="counter">
                          <button className="counter__btn counter__btn--decrement" onClick={handleDecrement}>-</button>
                          <input type="text" className="counter__input" value={quantity} readOnly />
                          <button
                            className="counter__btn counter__btn--increment"
                            onClick={() => handleIncrement()}
                          // disabled={quantity === maxquantity}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Contenedor del modal */}
                    {product.find_your_size && <div id="modal-talla" className="modal-talla" style={{ display: "none", maxWidth: "700px" }}>
                      <div className="modal-content">
                        <h2><i></i>{translate('product.find_size')}</h2>
                        <div className="text"><strong>{translate('product.important')}: </strong>{translate('product.size_description')} </div>
                        <img src={product?.collection_img_table ?? imgLayer} alt="Guía de tallas" />
                      </div>
                    </div>}

                    {/* <div className="other-payment-methods">
                      <div className="title">Importante:</div>
                      <div className="text">
                        <div className="box">Si quieres pagar con <img src={logozelle} alt="zelle" /> ó <img src={logovenmo} alt="venmo" /> por favor contáctanos al correo <a href="" target="_blank">ejemplo@mail.com</a> ó escríbenos por <a href="" target="_blank">WhatsApp</a>.</div>
                      </div>
                    </div> */}

                    {product.sizes.some(size => size.quantity > 0) ? (
                      <>
                        <div className="ButtonDarkMedium" onClick={() => { agregarAlCarrito() }}>
                          <i className="icon-Trolley"></i>
                          {translate('product.add_cart')}
                        </div>
                        <div
                          className="ButtonLightMedium"
                          onClick={() => comprarAhora()}
                        >
                          {translate('product.buy')}
                        </div>
                      </>
                    ) : (
                      <div className="ButtonDarkMedium" onClick={handleModalOpen}>
                        <i className="icon-Bell"></i>
                        {translate('product.leet_me')}
                      </div>
                    )}
                    {isModalOpen && <ProductoAgotadoBox isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}
                      // onClose={() => setIsModalOpen(false)}
                      product={product} />}
                    <div className="TeAvisaremos Hide">
                      <i className="icon-Check"></i>
                      <span>
                        {translate('product.will_send')}
                      </span>
                    </div>
                    <div className="description">
                      <h6>{translate('product.detail')}:</h6>
                      <p dangerouslySetInnerHTML={{ __html: product.detail }} />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Contacto */}
            {/* <article className="Sticky">
              <a href={translate('product.mailto')} target="_blank" rel="noopener noreferrer">
                <button className="ButtonContent ButtonDark">
                  {translate('product.contact')}<br />
                  {translate('product.contact2')}
                </button>
              </a>
            </article> */}
            {product && product.related.length > 0 &&
              <PodriaInteresarte
                title={translate('relacioned')}
                products={product.related}
              />}
          </>
      )}

    </>
  );
};


export default DetallesProducto;
